export default "__VITE_ASSET__CehPJDZ4__"